// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"vU-z","inlineTitle":"wU-z","sponsoredAdsWrapper":"xU-z","marketplaceRecosWrapper":"yU-z"};